import { Group, Paper, Text } from "@mantine/core";
import { nodeEventWidth } from "../../flowSettings";
import EventSelector from "./EventSelector";
import DelaySelector from "./DelaySelector";
import { getEvents } from "./events";
import { useFlowStore } from "../../../../../../../stores/WorkflowStore";
import { useMemo } from "react";
import { useModelsStore } from "../../../../../../../stores/ConfigStore";
import EventFilter from "./EventFilter";
import Linker from "./Linker";

const EventNode = ({ data, id, xPos, yPos }) => {
  const nodes = useFlowStore((s) => s.nodes);
  const linking = useFlowStore((s) => s.linking);
  const nodeSource = useMemo(
    () => nodes.find((x) => x.id === data?.source),
    [data?.source, nodes]
  );
  const models = useModelsStore((s) => s.model_emails);
  const workflowProfile = useFlowStore((s) => s.profile);

  const sourceModel = useMemo(() => {
    return models.find((x) => x.id === nodeSource?.data?.model_id);
  }, [models, nodeSource?.data?.model_id]);

  const messagesAreOnlyChildren = useMemo(() => {
    if (workflowProfile?.created_on) {
      return false;
    }
    let parentIsInvitation =
      nodeSource?.data?.actionType === "linkedin_invitation";

    if (parentIsInvitation) {
      let children = nodes?.filter((x) => x.data.source === id);
      if (children?.find((x) => x?.data?.actionType !== "linkedin_message")) {
        return false;
      }
      return true;
    }

    return false;
  }, [id, nodeSource?.data?.actionType, nodes, workflowProfile?.created_on]);

  const goodEvent = useMemo(() => {
    const correctEvents = getEvents(
      nodeSource?.data?.actionType,
      !!workflowProfile?.auto_remove_responders,
      messagesAreOnlyChildren
    );
    // if (data?.event_type === "link_click") {
    //   return sourceModel?.links?.length > 0;
    // }
    if (correctEvents.find((x) => x.value === data?.event_type)) {
      return true;
    }
    if (nodeSource?.data?.actionType === "call") return true;
    return false;
  }, [
    data?.event_type,
    messagesAreOnlyChildren,
    nodeSource?.data?.actionType,
    // sourceModel?.links?.length,
    workflowProfile?.auto_remove_responders,
  ]);

  return (
    <Paper
      w={nodeEventWidth}
      withBorder
      p={"xs"}
      className="action-node event"
      pos={"relative"}
      style={{
        borderWidth: 1,
        boxShadow: "#00000018 0 2px 3px",
        cursor: "default",
        borderColor: data?.error
          ? "var(--mantine-color-red-6)"
          : "var(--mantine-color-gray-3)",
      }}
      radius={"md"}
      pt={32}
      bg={"primary.0"}
    >
      {/* <Flex
        pos={"absolute"}
        top={-16}
        left={"50%"}
        bg={"#fff"}
        style={{
          border: "1px solid #00000033",
          borderRadius: 12,
          width: 64,
          height: 32,
          transform: "translateX(-50%)",
        }}
        align={"center"}
      >
        <Text size="lg" ta={"center"} w={"100%"} fw={700} style={{letterSpacing: -.5}}>
          S i
        </Text>
      </Flex> */}
      <Text size="md" w={"100%"} fw={600} mt={-24} ml={8} mb={4}>
        Condition
      </Text>
      <Group align="center" gap={4} wrap="nowrap">
        <EventSelector
          event_type={data?.event_type}
          event_name={data?.name}
          goodEvent={goodEvent}
          id={id}
          which_links_clicked={data?.which_links_clicked}
          nodeSource={nodeSource}
          sourceModel={sourceModel}
          messagesAreOnlyChildren={messagesAreOnlyChildren}
          disabled={data?.number_contacts > 0}
        />
        {nodeSource?.data?.actionType !== "split_contacts" && (
          <EventFilter
            filter={data?.filter}
            id={id}
            disabled={data?.number_contacts > 0}
          />
        )}
      </Group>

      <DelaySelector
        id={id}
        when_minutes={data?.when_minutes}
        event_type={data?.event_type}
      />

      {!linking && <Linker id={id} xPos={xPos} yPos={yPos} type={"event"} />}
    </Paper>
  );
};

export default EventNode;
